'use strict';

import type { AutomationAction } from '../../Entities/Automation/AutomationAction';
import { EntityCollection } from '../EntityCollection';

export class AutomationActionCollection extends EntityCollection<AutomationAction> {}
